/*
 * Copyright (c) 2025 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();import React, { ReactNode } from 'react'
import { cn } from '@/utils/css'

/** A description of the available properties for this component. */
type ManualContentCardProps = {
  /** The content to be displayed inside the card. */
  children: ReactNode
} & React.HTMLAttributes<HTMLDivElement>

/**
 * A reusable component for displaying main content blocks with consistent styling.
 * It applies a white background, padding, rounded corners, and a subtle shadow.
 */
const ManualContentCard: React.FC<ManualContentCardProps> = ({ children, className, ...rest }) => {
  return (
    <div
      className={cn(
        'bg-manuals-card-bg text-manuals-text text-base whitespace-pre-line p-4 rounded-xl shadow-sm border mb-6',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  )
}

export { ManualContentCard }
